<template>
    <v-container fluid class="pa-0 pt-4">
        <div class="image">
            <!-- <video preload="true" loop autoplay muted class="video">
                <source src="@/assets/intro-video.mp4" type="video/mp4" />
            </video> -->
            <!-- <video class="video" tabindex="0" autoplay muted controls
                aria-label="Vídeo de introdução explicando a plataforma">
                <source src="@/assets/intro-video.mp4" type="video/mp4" />
            </video> -->
            <!-- <v-img src="@/assets/home_logo_large.jpeg" class="fill-height image-home"></v-img> -->
        </div>

        <div class="px-12">
            <v-row>
                <v-col>
                    <h2 tabindex="0" class="page-subtitle text-justify">Bem-vindo(a)</h2>
                </v-col>
            </v-row>

            <!-- <v-row no-gutters>
                <v-col>
                    <span class="page-subtitle text-justify">Conheça a plataforma </span>
                    <br>
                    <iframe width="600" height="500" src="https://www.youtube.com/embed/cW5OmY0sP-o" frameborder="0"
                        allowfullscreen></iframe>
                </v-col>
            </v-row> -->

            <v-row>
                <v-col>
                    <p class="text-justify" tabindex="0">
                        Este site é mantido pelos Administradores Judiciais nomeados pela 1ª Vara Empresarial de Belo
                        Horizonte/MG: Paoli, Balbino e Balbino Administração Judicial, Brizola e Japur Administração
                        Judicial e Inocêncio de Paula Administradora Judicial.
                        <br />
                        <br />
                        Por meio desta plataforma, os credores das empresas 123 VIAGENS E TURISMO LTDA., ART VIAGENS E
                        TURISMO LTDA., NOVUM INVESTIMENTOS PARTICIPAÇÕES S.A., LH - LANCE HOTEIS LTDA. e MM TURISMO &
                        VIAGENS S.A. podem acompanhar as principais informações sobre o processo de Recuperação
                        Judicial.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col align="center">
                    <span tabindex="0" class="text-justify page-subtitle font-weight-bold">A FASE DE REVISÃO DE CRÉDITO
                        E ADESÃO AO PLANO DE RECUPERAÇÃO JUDICIAL COMEÇOU!
                    </span>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <p class="text-justify" tabindex="0">
                        A relação de credores após a verificação de créditos realizada pela Administração Judicial (art.
                        7º, §2º da LRF) está disponível na aba “LISTA 123 MILHAS”.
                        <br />
                        <br />
                        Caso você discorde do seu crédito ou do resultado da sua análise, bem como pretenda habilitar
                        utilize da fase de “Revisão de Créditos” para realizar a sua solicitação. Os credores que ainda
                        não se encontram na Lista de Credores podem utilizar desta mesma fase para habilitar o seu
                        crédito.
                        <br />
                        <br />
                        Por outro lado, caso você concorde com o seu crédito, você poderá utilizar da plataforma para
                        aderir ao Plano de Recuperação Judicial apresentado pelas Recuperandas.
                        <br />
                        <br />
                        Conforme a Decisão proferida no ID nº 10581712116, datada de 14/11/2025, pelo Juízo da 1ª Vara
                        Empresarial da Comarca de Belo Horizonte/MG, a fase prévia e preliminar de "Revisão de Créditos"
                        e de “Colheita de Votos e Adesão ao Plano de Recuperação Judicial via Plataforma da
                        Administração Judicial” se inicia no dia subsequente à publicação do Edital previsto no art. 7º,
                        § 2º, da Lei nº 11.101/2005, ou seja, 01/12/2025.
                        <br />
                        <br />
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col align="center">
                    <span tabindex="0" class="text-justify page-subtitle font-weight-bold">Instruções para Credores:
                    </span>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <p class="text-justify" tabindex="0">
                        <strong>Prazo:</strong> Os credores que irão participar da ”Revisão de Créditos” terão o prazo
                        de 10 (dez) dias
                        corridos para o seu cadastramento, contados da publicação do Edital de Convocação, que também
                        dará conhecimento da Relação de Credores, conforme o disposto no art. 7º, § 2º, da Lei nº
                        11.101/2005.
                        <br />
                        <br />
                        <strong>Obs:</strong> Este prazo não será aplicado aos credores que, somente, pretendem realizar
                        a Adesão ao
                        Plano de Recuperação Judicial via Plataforma da Administração Judicial.
                        <br />
                        <br />
                        <br />
                        <strong>Consulta à Decisão:</strong>
                        <br />
                        <br />
                        A íntegra da Decisão referida pode ser consultada por meio da aba "Sobre o Processo" ->
                        "Principais Documentos" -> "Decisões" -> "271. Decisão - Publicação Edital Termo de Adesão e
                        Mediação".
                        <br />
                        <br />
                        <br />
                        <strong>Consulta ao Plano de Recuperação Judicial:</strong>
                        <br />
                        <br />
                        Para conhecer a íntegra do Plano de Recuperação Judicial apresentado pelo Grupo 123 Milhas,
                        acesse a aba “Sobre o Processo” > “Principais Documentos” > “Plano de Recuperação Judicial” e
                        selecione o documento “238. Plano de Recuperação Judicial”.
                        <br />
                        <br />
                        O documento “242. Relatório sobre o Plano de Recuperação Judicial elaborado pela Administração
                        Judicial” esclarece, de forma mais simplificada, as formas de pagamento propostas pelo Grupo 123
                        Milhas.
                        <br />
                        <br />
                        <br />
                        <strong>Atenção!</strong> A participação na fase de Revisão de Créditos e/ou na Adesão ao Plano
                        de Recuperação
                        Judicial não significa o início automático dos pagamentos. Após o fim destas fases, a Assembleia
                        Geral de Credores será convocada para deliberar sobre a votação do Plano de Recuperação
                        Judicial.
                        <br />
                        <br />
                        <br />
                        Link para os vídeos e arquivos tutoriais que irão auxiliar na utilização dos principais itens do
                        site, elaborados pela Administração Judicial: <a target="_blank"
                            href="https://rj123milhas.com.br/#/ajuda">https://rj123milhas.com.br/#/ajuda</a>
                        <br />
                        <br />
                        Link sobre dúvidas disponibilizado pelas empresas:
                        <a href="https://123milhas.custhelp.com/app/Recuperacao-Judicial"
                            target="_blank">https://123milhas.custhelp.com/app/Recuperacao-Judicial</a>
                        <br />
                        <br />
                        Link para atendimento, em caso de dúvidas sobre o plano:
                        <a target="_blank"
                            href="https://123milhas.custhelp.com/app">https://123milhas.custhelp.com/app</a>
                    </p>
                </v-col>
            </v-row>

            <Calendar />
        </div>

        <!-- <v-dialog v-model="dialogPopup" :width="700">
            <v-img src="@/assets/images/popup-prazo.png">
                <div align="right">
                    <v-btn icon elevation="0" @click="dialogPopup = false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </v-img>
        </v-dialog> -->

        <!-- <v-dialog v-model="dialogPopup" :width="600">

            <v-card>
                <v-img src="@/assets/images/popup-revisao.png" height="auto" width="600"></v-img>
                <v-card-actions>
                    <v-btn color="primary" @click="dialogPopup = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog> -->

        <v-dialog v-model="dialogPopup" :width="600">

            <v-card>
                <v-carousel v-if="bannerImages.length > 1" cycle interval="5000" hide-delimiters height="auto"
                    show-arrows-on-hover>
                    <v-carousel-item v-for="(image, index) in bannerImages" :key="index" :src="image"></v-carousel-item>
                </v-carousel>
                <v-img v-else :src="bannerImages[0]" height="auto" width="500"></v-img>
                <v-card-actions>
                    <v-btn color="primary" @click="dialogPopup = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>

        <v-dialog v-if="recoveryToken" persistent v-model="dialogRecoverPassword" :width="600" tabindex="0"
            aria-label="Recuperação de senha">
            <recover-password-component :token="recoveryToken"></recover-password-component>
        </v-dialog>
    </v-container>
</template>

<script>
import 'moment/locale/pt-br'

import { eventHub } from '@/main'
import axios from 'axios'

import RecoverPassword from '@/views/user/RecoverPassword.vue'
import Calendar from "@/layouts/components/Calendar.vue";

export default {
    components: {
        Calendar,
        'recover-password-component': RecoverPassword
    },

    data: () => ({
        user: null,
        dialogPopup: false,
        recoveryToken: null,
        dialogRecoverPassword: false,
        bannerImages: []
    }),

    mounted() {
        this.loadBanner();
    },

    created() {
        this.dialogPopup = true;

        this.$ga.event({
            eventCategory: 'page',
            eventAction: 'action',
            eventLabel: 'click',
            eventValue: 'home'
        })

        eventHub.$on('DIALOG-CHANGE-PASSWORD', value => {
            if (!value) this.$router.replace('/home')

            this.dialogRecoverPassword = value
        })

        eventHub.$on('DIALOG-REGISTER', value => {
            if (!value) this.$router.replace('/home')

        })

        if (this.$route.query.token) {
            this.dialogPopup = false;

            this.verifyAccount(this.$route.query.token)
        }

        if (this.$route.query.recoveryToken) {
            this.dialogPopup = false;

            this.verifyRecoverPasswordToken(this.$route.query.recoveryToken)
        }
    },

    methods: {
        openRegister() {
            eventHub.$emit('DIALOG-REGISTER', true)
        },

        async verifyAccount(token) {
            if (!token) return

            this.loading = true

            try {
                const normalizedToken = decodeURIComponent(token.toString().replaceAll(' ', '+'))

                const result = await axios.post('/api/users/verify-account', { token: normalizedToken })

                if (!result.data.status) throw new Error()

                const accountType = result.data.content.type

                let message = ''
                if (accountType === 'lawyer') {
                    message = 'Conta verificada com sucesso! Realize o login para acessar a "Área do Procurador".'
                } else {
                    message = 'Conta verificada com sucesso! Realize o login para acessar a "Área do Credor".'
                }

                await this.$dialog.confirm({
                    text: message,
                    title: 'Sucesso',
                    actions: {
                        true: 'OK'
                    }
                })

                this.$router.replace('/home')
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 })
            } finally {
                this.loading = false
            }
        },

        async loadBanner() {

            try {
                const result = await axios.get('/api/banners/active-list');

                this.bannerImages = result.data.content.data;

                if (this.bannerImages.length) this.dialogPopup = true;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            }

        },

        async verifyRecoverPasswordToken(token) {
            if (!token) return

            this.recoveryToken = decodeURIComponent(token.toString().replaceAll(' ', '+'))

            this.dialogRecoverPassword = true
        }
    }
}
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.image {
    width: 100vw;
    overflow: hidden;
    z-index: 999;
}

.video-container {
    max-width: 100%;
    max-height: 100%;
}

.video {
    width: 100%;
    height: auto;
}
</style>
